import type { DocumentViewerKind } from "@volca/ui/components/ui/document-viewer";
import { citationSearch } from "@/profitability/documents/citation";
import { profitabilityPeriodPath } from "@/profitability/routes";
import { documentCitation } from "./sourced";
import type { RunCitation } from "./types";

/**
 * The template's Documents tab on the run's period, opened on the same
 * document at the same place (`?doc=&view=&page=&box=&sheet=&row=&col=`).
 */
export const documentsHref = ({
  reportId,
  runId,
  compare,
  citation,
  kind,
}: {
  reportId: string;
  runId: string;
  compare: string | null;
  citation: RunCitation;
  kind: DocumentViewerKind | null;
}) => {
  const search = citationSearch(
    citation.document_id,
    documentCitation(citation, kind),
    kind ? "original" : "preview",
  );
  if (compare) search.set("compare", compare);
  return `${profitabilityPeriodPath(reportId, runId, "documents")}&${search.toString()}`;
};
